import React from 'react';
import { SurveyDefinition, SurveyStepDefinition } from '../../../types/Survey';
import { DelegatedOAuthClient } from '../../../context/PageSetupContext';

export interface SurveyStepContext {
    mode: "Design" | "Preview" | "Survey";
    surveyDefinition: SurveyDefinition;
    stepDefinition: SurveyStepDefinition;
    webViewStepFrameUrl?: string;
    delegatedOAuthClient?: DelegatedOAuthClient;
}

export const SurveyStepContext = React.createContext<SurveyStepContext | null>(null);
